import {ProgressHeaderWithPopup} from "../components/progressHeaderWithPopup"; // update path if needed
import { HeadLogo } from "../components/headLogo";
import {LocationImageDisplay} from "../components/locationImageDisplay";


function ArrivalCheckView({ imageKey, location, onProceed }) {


  return (
    <div className="fixedLayout">
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={1} />
      <div className="global-screen-content">
        <div className="left-align">
          <div className="global-question_screen-question-text">
            Have you 
            <br />
             arrived at  <br />
            <div
              className="global-question_screen-highlight"
              style={{ display: "inline" }}
            >
              {location.title}
            </div> 
            <br />
            yet?
          </div>

          <div className="global-ctabutton-vertical">
            <button
              className="global-main_calltoaction_btn"
              onClick={() => onProceed(true)}
            >
              Yes
            </button>
            <button
              className="global-main_calltoaction_btn inverse"
              onClick={() => onProceed(false)}
            >
              I Haven't
            </button>
          </div>
        </div>
      </div>
      <LocationImageDisplay imageKey={imageKey} dynamicHeight="50vh" />
    </div>
  );
}

export { ArrivalCheckView };
